module.exports = __webpack_public_path__ + "img/title7.084969b4.png";